import selectionUtils from 'utils/selectionUtils';

function init(editor) {
    function onSelectionCheck() {
        selectionUtils.fixSelectionOnBodyIfNeeded(editor);
        selectionUtils.fixSelectionOnPlaceHolder(editor);
    }

    editor.on('selectionCheck', onSelectionCheck, null, null, 99999);//http://docs.ckeditor.com/#!/api/CKEDITOR.event-method-on if you need to understand these extra params
}

export default {
    init: init
};
